<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/merchantaccess/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
    >
      <el-form-item label="代理商ID">
        <el-input v-model="formModel.userId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="商户号">
        <el-input
          v-model="formModel.merchantNo"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="formModel.status">
          <el-option
            v-for="item in status"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <!-- <el-form-item label="创建时间">
        <el-date-picker
          v-model="time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item> -->
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="traceNo"
        label="流水号"
        :formatter="formatterTableData"
        min-width="300"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="agentId"
        label="代理商ID"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merchantNo"
        label="商户号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merchantName"
        label="商户名称"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="licenseType"
        label="商户类型"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        fixed="right"
        prop="status"
        label="状态"
        :formatter="formatterTablestatus"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        fixed="right"
        prop="uploadStatus"
        label="文件上传状态"
        :formatter="formatterTableuploadStatus"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        fixed="right"
        prop="checkStatus"
        label="审核提交状态"
        :formatter="formatterTablecheckStatus"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        v-if="hasPerm('/merchantaccess/sh')"
        label="操作"
        min-width="180"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.uploadStatus == 0 || scope.row.uploadStatus == 2"
            type="text"
            @click="handleupdate(scope.row)"
            >上传文件
          </el-button>
          <span v-else>已上传文件</span>

          <el-button
            v-if="scope.row.checkStatus == 0 || scope.row.checkStatus == 2"
            type="text"
            @click="handlesh(scope.row)"
            >提交审核
          </el-button>
          <span v-else>已提交审核</span>
        </template>
      </el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import RichService from "service/RichService";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "merchantaccess",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    return {
      time: "",
      status: [
        {
          dictKey: "",
          dictValue: "全部",
        },
      ],
      checkStatus: [
        {
          code: "",
          name: "全部",
        },
        {
          code: "0",
          name: "未提交",
        },
        {
          code: "1",
          name: "已提交",
        },
        {
          code: "2",
          name: "审核失败",
        },
      ],
      uploadStatus: [
        {
          code: "",
          name: "全部",
        },
        {
          code: "0",
          name: "未上传",
        },
        {
          code: "1",
          name: "已上传",
        },
        {
          code: "2",
          name: "上传失败",
        },
      ],
      formModel: {
        userId: "",
        merchantNo: "",
        status: "",
      },
      tableData: [],
      submitService: RichService.merchantaccessList,
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
    this.getTypeNames("FyMerchantStatus", (res) => {
      this.status = [...this.status, ...res];
    });
  },
  computed: {
    submitData() {
      //   if (this.time == null || this.time == "") {
      //     this.time = [];
      //   }
      const params = {
        userId: this.formModel.userId,
        merchantNo: this.formModel.merchantNo,
        status: this.formModel.status,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      //   if (this.time.length) {
      //     params.startTime = this.time[0];
      //     params.endTime = this.time[1];
      //   }
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  watch: {},
  methods: {
    load() {
      this.formModel = {
        status: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    handleupdate(item) {
      this.showConfirm("是否上传文件？")
        .then(() => {
          this.update(item.id);
        })
        .catch(() => {});
    },
    update(id) {
      this.doLoad(
        RichService.merchantaccessUpdateFile,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    handlesh(item) {
      this.showConfirm("是否提交审核？")
        .then(() => {
          this.sh(item.id);
        })
        .catch(() => {});
    },
    sh(id) {
      this.doLoad(
        RichService.merchantaccessSh,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    formatterTablestatus(row, column, cellValue, index) {
      let value = "";
      this.status.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });

      return value ? value : "--";
    },
    formatterTablecheckStatus(row, column, cellValue, index) {
      let value = "";
      this.checkStatus.forEach((item) => {
        if (item.code == cellValue) {
          value = item.name;
        }
      });

      return value ? value : "--";
    },
    formatterTableuploadStatus(row, column, cellValue, index) {
      let value = "";
      this.uploadStatus.forEach((item) => {
        if (item.code == cellValue) {
          value = item.name;
        }
      });

      return value ? value : "--";
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/Rich/MerchantAccess.vue